import { FormattedMessage } from 'react-intl';

import './index.css';
import { CodeSearch } from 'routes/secondary-market-batch/header/code-search';
import { ExportButton } from 'routes/secondary-market-batch/header/export-buttons';
import { OrderTypeSelector } from 'routes/secondary-market-batch/header/order-type-selector';

export function Header() {
  return (
    <div className="d-flex border-top secondary-batch-header" role="region" aria-label="Header">
      <div className="d-flex align-items-center gap-3 flex-grow-1">
        <h5 className="ms-3 text-md-nowrap">
          <FormattedMessage id="secondary-market-batch.page.title" />
        </h5>
        <div className="vertical-divider"></div>
        <OrderTypeSelector />
      </div>
      <CodeSearch className="ms-3" />
      <ExportButton />
    </div>
  );
}
